export default __webpack_public_path__ + "static/media/carbonblue.f2d0b69c.png";